import React, { Component } from "react";
import Head from "next/head";
import Navbar from "../../src/components/NavigationBar/Navbar";
import { withRouter } from "next/router";
import Footer from "../../src/components/Footer";
import WidgetComponent from "../../src/pages/Widget/WidgetComponent";
import { getQuery } from "../../src/helpers/utils";

class Widget extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<Head>
					<title>{`KonfHub - Technical Conferences Platform - Create | Gamify | Amplify`}</title>
				</Head>
				<WidgetComponent
					query={getQuery(this.props.router.query)}
					isReady={this.props.router.isReady}
				/>
			</>
		);
	}
}

export default withRouter(Widget);
